import React from 'react';

const cellWidthStyle = (width) => ({
  width,
});

const ContractLineHeader = ({ contract }) => {
  return (
    <tr className="contractLine">
      <th className="contractLine__head contractLine__center" style={cellWidthStyle('30px')}>
        #
      </th>
      <th className="contractLine__head contractLine__right" style={cellWidthStyle('60px')}>
        Price
      </th>
      <th className="contractLine__head">Start date</th>
      <th className="contractLine__head">End date</th>
      <th className="contractLine__head">Weight</th>
      <th className="contractLine__head">Distance</th>
      <th className="contractLine__head">Pallets</th>
      <th className="contractLine__head">Pickup zipcodes</th>
      <th className="contractLine__head">Dropoff zipcodes</th>
      <th className="contractLine__head">Description</th>
    </tr>
  );
};

export default ContractLineHeader;
